module.exports = __webpack_public_path__ + "static/img/7a90b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/txgg_zbfl.png
// module id = 631
// module chunks = 2